import * as React from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { useScrollRestorationContext } from '../../context/scrollRestoration';

export interface BreadcrumbLinkProps extends Omit<LinkProps, 'to'> {
  to: string
}

/**
 * A link up to a page that the user has come from, such as the "Performance" crumb on the page for one of its days.
 *
 * As far as scrolling goes it behaves like Back: the page is shown at the scroll position it was left at, instead of
 * at the top as for other links. Without ScrollRestoration around it, it is just a Link.
 */
export const BreadcrumbLink = React.forwardRef<HTMLAnchorElement, BreadcrumbLinkProps>(({ to, onClick, ...rest }, ref) => {
  const { restoreOnNextNavigation } = useScrollRestorationContext();

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    // Whether Link goes on to navigate (it doesn't for a modified click, say) needn't be worked out here: the request
    // only lasts for this event, so if nothing navigates, nothing uses it.
    restoreOnNextNavigation(to);
    onClick?.(event);
  };

  return <Link ref={ref} to={to} onClick={handleClick} {...rest} />;
});
